
<div  class="container-fluid pagecard" style="height:74vh;">
  <div class="empty-card d-flex align-items-center justify-content-center mt-5">
    <div class="col-4">
      <div class="d-flex justify-content-center mb-3">
        <img
          src="assets\images\al-price.svg"
          class="card-img-top"
          style="width: 171px"
          alt="..."
        />
      </div>
      <div class="card-body text-center">
        <h5 class="card-title mb-4 text-xl" >Price Comparison</h5>
        <p class="card-text mb-4">We are gathering the data required to get you the most accurate price comparison information.</p>
      </div>
    </div>
  </div>
</div>